import {AsyncStatusesEnum} from '../../../../libs/shared/helpers/src/types/asyncStatuses';
import {randomString} from '../../../../libs/shared/helpers/src/utilities/stringHelpers';
import {AsyncMoreStatusesEnum} from '../../appTypes';
import {
  InboxesConversationsParameters,
  InboxesParameters,
  InboxesParametersTypesEnum,
  InboxesTeammateMessagesParameters,
} from '../inboxes/parameters/inboxesParameters';
import {
  CellsPanelConversationsPageState,
  CellsPanelMessagesPageState,
  CellsPanelPageTypesEnum,
} from './cellsPanelState';
import {CellsContext} from './context/cellsContext';

export function buildCellsPanelPage(parameters: InboxesParameters, cellsContext: CellsContext) {
  return parameters.type === InboxesParametersTypesEnum.TEAMMATE_MESSAGES
    ? buildCellsPanelMessagesPageState(parameters, cellsContext)
    : buildCellsPanelConversationsPageState(parameters, cellsContext);
}

export function makeCellsPanelPageUid() {
  return randomString();
}

/** Build a new message cells page with the correct defaults. */
function buildCellsPanelMessagesPageState(
  parameters: InboxesTeammateMessagesParameters,
  cellsContext: CellsContext,
): CellsPanelMessagesPageState {
  return {
    uid: makeCellsPanelPageUid(),
    type: CellsPanelPageTypesEnum.MESSAGES,
    parameters,
    cellsContext,
    status: AsyncStatusesEnum.LOADING,
    isLoadedFromCache: false,
    isRefetching: false,
    moreStatusTop: AsyncMoreStatusesEnum.NONE,
    moreStatusBottom: AsyncMoreStatusesEnum.NONE,
    topBoundary: undefined,
    bottomBoundary: undefined,
    messageUids: [],
  };
}

/** Build a new conversation cells page with the correct defaults. */
function buildCellsPanelConversationsPageState(
  parameters: InboxesConversationsParameters,
  cellsContext: CellsContext,
): CellsPanelConversationsPageState {
  return {
    uid: makeCellsPanelPageUid(),
    type: CellsPanelPageTypesEnum.CONVERSATIONS,
    parameters,
    cellsContext,
    status: AsyncStatusesEnum.LOADING,
    isLoadedFromCache: false,
    isRefetching: false,
    moreStatusTop: AsyncMoreStatusesEnum.NONE,
    moreStatusBottom: AsyncMoreStatusesEnum.NONE,
    topBoundary: undefined,
    bottomBoundary: undefined,
    conversationIds: [],
    conversationHighlights: {},
    conversationMatchedQueries: {},
    conversationSearchResults: undefined,
    removedConversationIds: [],
    hiddenConversationId: null,
    conversationOverlays: {},
  };
}
